import type { SxProps, Theme } from '@/ui/primitives';

export const tableV2HeaderLabelSx = {
  display: 'block',
  maxWidth: '100%',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} satisfies SxProps<Theme>;
